import React from "react";
import ReactDOM from "react-dom";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "bootstrap-css-only/css/bootstrap.min.css";
import "mdbreact/dist/css/mdb.css";
import "./index.css";
import { BrowserRouter as Router } from "react-router-dom";
import App from "./App";

import SellerPrmProvider from "./context/SellerPrmProvider";

import registerServiceWorker from "./registerServiceWorker";

ReactDOM.render(
  <Router>
    <SellerPrmProvider>
      <App />
    </SellerPrmProvider>
  </Router>,
  document.getElementById("root")
);

registerServiceWorker();
